import * as React from 'react'

import {
  getInputAdornmentClasses,
  getInputContainerClasses,
  getInputFieldClasses,
} from '~/@/lib/style-utils'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  containerClassName?: string
  endAdornment?: React.ReactNode
  endAdornmentSpacing?: string
  isBorderless?: boolean
  startAdornment?: React.ReactNode
  startAdornmentSpacing?: string
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      disabled,
      endAdornment,
      endAdornmentSpacing = 'me-2',
      isBorderless,
      onMouseEnter,
      onMouseLeave,
      readOnly,
      startAdornment,
      startAdornmentSpacing = 'ms-2',
      type,
      ...props
    },
    ref,
  ) => {
    return (
      <div
        className={getInputContainerClasses(disabled, undefined, isBorderless, readOnly)}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {startAdornment && (
          <div
            className={getInputAdornmentClasses(
              'start',
              disabled,
              undefined,
              startAdornmentSpacing,
            )}
          >
            {startAdornment}
          </div>
        )}

        <input
          ref={ref}
          type={type}
          className={getInputFieldClasses(type, className)}
          disabled={disabled}
          readOnly={readOnly}
          {...props}
        />

        {endAdornment && (
          <div className={getInputAdornmentClasses('end', disabled, endAdornmentSpacing)}>
            {endAdornment}
          </div>
        )}
      </div>
    )
  },
)

Input.displayName = 'Input'

export { Input }
